var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadIconfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "url(#paint0_linear_1240_106)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.4H8.33333V18.6H17.6667V10.2H15V7.4ZM7 6.69426C7 6.31084 7.29833 6 7.66567 6H15.6667L18.9998 9.5L19 19.2948C19 19.6842 18.7034 20 18.3377 20H7.66227C7.29651 20 7 19.6813 7 19.3057V6.69426ZM13.6667 13V15.8H12.3333V13H10.3333L13 10.2L15.6667 13H13.6667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1240_106",
    x1: 14.7105,
    y1: -5.81579,
    x2: 13,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF03CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B0CB2"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadIconfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload-iconfile.dfa057c568a46e4e35357d98ccd5e262.svg";